import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useIsNavigationRedesignEnabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.ADMIN_APP_NAVIGATION_REDESIGN_ENABLED, {
    defaultValue: false,
  });
}
